import React from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import PhoneIcon from "@material-ui/icons/Phone";
import CakeIcon from "@material-ui/icons/Cake";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import PublicIcon from "@material-ui/icons/Public";
import StreetviewIcon from "@material-ui/icons/Streetview";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import AddLocationIcon from "@material-ui/icons/AddLocation";

let FromDetails = {
  primaryDetails: {
    applicantId: {
      elementType: "input",
      elementConfig: {
        type: "text",
        autoFocus: true,
        label: "Applicant ID",
        autoComplete: "Student ID",
        name: "ses_applicant",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    emailaddress1: {
      elementType: "input",
      elementConfig: {
        type: "email",
        label: "Email Address",
        autoComplete: "email",
        name: "emailaddress1",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <MailOutlineIcon style={{ color: "#959595" }} />,
      value: "",
    },
    firstname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        autoFocus: true,
        label: "First Name",
        autoComplete: "first-name",
        name: "firstname",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
     ses_preferredname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        autoFocus: true,
        label: "Preferred Name",
        autoComplete: "preferred-name",
        name: "ses_preferredname",
        required: false,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    middlename: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Middle Name",
        autoComplete: "middle-name",
        name: "middlename",
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    lastname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Last Name",
        autoComplete: "last-name",
        name: "lastname",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    birthdate: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Birthday",
        autoComplete: "birthdate",
        name: "birthdate",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <CakeIcon style={{ color: "#959595" }} />,
      value: "",
    },
    gendercode: {
      elementType: "select",
      elementConfig: {
        options: [
          { value: 2, displayValue: "Female" },
          { value: 1, displayValue: "Male" },
          { value: 943240003, displayValue: "Non-binary" },
          { value: 943240010, displayValue: "Transgender" },
          { value: 943240005, displayValue: "Two-spirit" },
          { value: 943240011, displayValue: "Other" },
          { value: 943240009, displayValue: "I prefer not to answer" },
        ],
        name: "gendercode",
        label: "Gender",
      },
      value: "",
      disabled: true,
    },
  },
  contact: {
    mobilephone: {
      elementType: "inputNumber",
      elementConfig: {
        type: "number",
        label: "Mobile",
        autoComplete: "mobilephone",
        name: "mobilephone",
        fullWidth: true,
        belowText: "",
      },
      icon: <PhoneAndroidIcon style={{ color: "#959595" }} />,
      value: "",
    },
    ses_optinfortextmessages: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        aboveText:
          "I accept to receive transactional and promotional SMS messages from the University (to the number indicated above).",
        name: "ses_optinfortextmessages",
        display: "none",
      },
      value: "",
    },
    home2: {
      elementType: "inputNumber",
      elementConfig: {
        type: "number",
        label: "Home",
        autoComplete: "home2",
        name: "home2",
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
    business2: {
      elementType: "inputNumber",
      elementConfig: {
        type: "number",
        label: "Office",
        autoComplete: "business2",
        name: "business2",
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  HomeAddress: {
    _ses_countryofresidence_value: {
      elementType: "select",
      elementConfig: {
        label: "Country *",
        name: "_ses_countryofresidence_value",
        // required: true,
        options: [],
      },
      maxLength: 80,
      isValid: false,
      errorMessage: "Country can't be blank",
      icon: <PublicIcon style={{ color: "#959595" }} />,
      value: "",
      disabled: false,
    },
    address1_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street",
        autoComplete: "Street",
        name: "address1_line1",
        required: true,
        fullWidth: true,
      },
      icon: <StreetviewIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "City",
        name: "address1_city",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    ses_stateorprovince: {
      elementType: "select",
      elementConfig: {
        label: "State or Province",
        name: "ses_stateorprovince",
        required: true,
        fullWidth: true,
        options: [],
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Zip Code/Postal Code",
        autoComplete: "Zip Code/Postal Code",
        name: "address1_postalcode",
        required: true,
        fullWidth: true,
      },
      icon: <AddLocationIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
};

export default FromDetails;
